<template>     
    <section class="content">
        <div class="container-fluid p-0 p-md-2">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header d-flex flex-column flex-md-row align-items-center justify-content-between">
                            <h3 class="card-title mb-2 mb-md-0 flex-grow-1 text-md-left text-center">Listado de tipos de abonos</h3>
                            <div class="card-tools text-center">
                                <slot name="buttons"></slot>
                            </div>
                        </div>

                        <div class="card-body">
                            <div :class="[esMovil ? 'table-responsive' : '']">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Descripción</th>
                                            <th>Stock</th>
                                            <template v-if="!lista.place">
                                                <th class="text-center">Resumen</th>
                                                <th class="text-center">Eventos</th>
                                            </template>
                                            <th class="text-center">Activo</th>
                                            <th class="text-center">Renovación</th>
                                            <th class="text-center">Pago a plazos</th>
                                            <th class="text-center">Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="!loading">
                                        <template v-if="tipos.length > 0">
                                            <tr v-for="(tipo, index) in tipos" :key="index">
                                                <td>{{ tipo.descripcion }}</td>
                                                <td>
                                                    <ul>
                                                        <li>
                                                            <small class="text-nowrap">Stock: {{ tipo.stock }}</small>
                                                        </li>
                                                        <li>
                                                            <small class="text-nowrap">En sesión: {{ tipo.stock_sesion }}</small>
                                                        </li>
                                                        <li>
                                                            <small class="text-nowrap">Total: {{ tipo.stock_calculado }}</small>
                                                        </li>
                                                    </ul>
                                                </td>
                                                <template v-if="!lista.place">
                                                    <td class="text-center">{{ tipo.resumen }}</td>
                                                    <td class="text-center">
                                                        <b-button v-b-popover.hover="'Eventos: ' + tipo.eventos.map(e => e.name).join(', ')" variant="primary" size="sm">
                                                            Ver eventos
                                                        </b-button>
                                                    </td>
                                                </template>
                                                <td class="text-center">
                                                    <CheckOrCross :condition="tipo.activo"/>
                                                </td>
                                                <td class="text-center">
                                                    <CheckOrCross :condition="tipo.renovacion"/>
                                                </td>
                                                <td class="text-center">
                                                    <CheckOrCross :condition="tipo.activar_pago_plazos"/>
                                                </td>
                                                <td class="text-center">
                                                    <OpcionesDropdownTableComponent 
                                                        :lastIndex="tipos.length > 3 && index >= tipos.length - 3"
                                                        v-bind:options="[
                                                            { to: { name: 'back.abonos.precios.descuentos', params: { precio_id: tipo.id }}, label: 'VER PRECIOS' },
                                                            { type: 'action', action:() => showModal('editarPrecio-' + tipo.id), label: 'EDITAR' },
                                                            { type: 'action', action:() => showModal('borrar-' + tipo.id), label: 'BORRAR' }
                                                        ]" 
                                                        @open="onOpenOptions" 
                                                        @close="onCloseOptions"
                                                    />
                                                </td>
                                                <slot name="editarPrecio" :index="index" :tipo="tipo"></slot>
                                                <DeletePrecioModal :key="index + '--'" :precio="tipo" :lista_id="lista.id" @close="closeModal"/>
                                            </tr>
                                        </template>
                                        <tr v-else>
                                            <td :colspan="lista.place ? 6 : 8" class="text-center py-4 text-muted">
                                                <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
                                                No hay tipos de abono configurados
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td :colspan="lista.place ? 6 : 8">
                                                <LoaderComponent/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <slot name="configurar-zonas" :tipos="tipos"></slot>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import DeletePrecioModal from '../../modals/DeletePrecioModal';
    import LoaderComponent from '@/components/preloader/LoaderComponent';
    import CheckOrCross from "@/components/backend/components/CheckOrCross";
    import OpcionesDropdownTableComponent from '@/components/backend/components/OpcionesDropdownTableComponent';

    export default {
        data() {
            return {
                loading: true,
                tipos: [],
                openOptions: [],
                esMovil: window.innerWidth <= 768
            }
        },
        computed: {
            lista() {
                return this.$store.getters.getListaAbonados;
            }
        },
        methods: {
            getTipos() {
                this.loading = true;
                const params = {
                    filters: { all: 1 },
                    lista_id: this.lista.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.precios.index'), params).then(res => {
                    this.tipos = res.data;
                })
                    .catch(() => {
                        this.$toast.error('Error al cargar los tipos de abono');
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, creado) {
                this.openOptions.forEach(opt => opt.close());
                this.openOptions = [];

                if (creado) {
                    this.getTipos();
                }

                this.$modal.hide(modal);
            },
            onOpenOptions(ref) {
                this.openOptions.push(ref);
            },
            onCloseOptions(ref) {
                const idx = this.openOptions.indexOf(ref);
                if (idx >= 0) {
                    this.openOptions.splice(idx, 1);
                } 
            },
            handleResize() {
                this.esMovil = window.innerWidth <= 768;
            }
        },
        created() {
            this.getTipos();
            window.addEventListener('resize', this.handleResize);
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        components: {
            CheckOrCross, LoaderComponent, DeletePrecioModal, OpcionesDropdownTableComponent
        }
    }
</script>

<style>
    .multiselect__tag {
        font-size: 9px;
    }
    .multiselect__tag-icon {
        line-height: 17px;
    }
</style>